<template>
  <div>
    <vs-row class="mt-1 al-center">
      <h4
        style="color: #808080; font-size: 18px; font-weight: 900"
        class="ml-2"
      >
        {{ text }}
      </h4>
      <vs-spacer />
      <!-- <vs-icon
        class="ml-2"
        @click="activePrompt = true"
        icon="settings"
      ></vs-icon>  -->
      <span style="margin-right: 10px">{{ textSelect }}</span>
      <span>
        <vs-icon
          icon="settings"
          v-b-modal.modal-1
          size="25px"
          color="gray"
        ></vs-icon> </span></vs-row
    ><br />
    <div style="position: relative; width: 100%">
      <!-- <LineChart
      v-if="datacollection_power != null"
        :height="heightgrapg"
        :chartData="datacollection_power"
        :optionsChart="option_power"
      ></LineChart> -->
      <!-- <stock-chart :chart="stockChart"/> -->
      <HLineChart
        :chart="linechartCom"
        :id="'line'"
        v-if="linechart.series != 0"
      />
    </div>

    <b-modal
      id="modal-1"
      no-close-on-backdrop
      ref="settingChart"
      hide-header-close
      centered
      size="lg"
    >
      <template #modal-title>
        <h4 class="textSuccess">Select Date</h4>
      </template>
      <!-- {{ arrSensor }} -->
      <div class="con-exemple-prompt p-3">
        <vs-select class="selectExample" label="Options" v-model="select1">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in options1"
          />
        </vs-select>
        <div v-if="select1 === 1" class="mt-4 p-2" id="selectitem">
          <a>Duration : </a>
          <vs-radio v-model="radios_hr" class="ml-2" vs-value="4">3hr</vs-radio>
          <vs-radio v-model="radios_hr" class="ml-2" vs-value="2">6hr</vs-radio>
          <vs-radio v-model="radios_hr" class="ml-2" vs-value="1"
            >12hr</vs-radio
          >
        </div>
        <div v-if="select1 === 2" class="mt-4 p-2" id="selectitem">
          <a>Date time : </a>
          <vc-date-picker
            v-model="dateRange"
            is-range
            mode="dateTime"
            :masks="masks"
            color="green"
            @input="getTagLog"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <div class="select-date ml-2">
                <div v-on="inputEvents.start" class="date-range">
                  <vs-icon icon="date_range"></vs-icon>
                  <div>
                    <span>
                      {{ inputValue.start }}
                    </span>
                    -
                    <span>
                      {{ inputValue.end }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </vc-date-picker>
        </div>
      </div>
      <template #modal-footer="{}">
        <vs-button
          color="success"
          class="mr-2 btnBorderpop"
          @click="accept()"
          type="filled"
          >OK</vs-button
        >
        <vs-button
          class="btnBorderpop"
          color="dark"
          @click="closeModal"
          type="flat"
          >Cancel</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
// import lineChart from "../BodyOutLine/Chart";
import LineChart from "@/components/ChartJs/LineChart.js";
import StockChart from "@/components/HighChart/StockChart.vue";
import HLineChart from "@/components/HighChart/LineChart.vue";

export default {
  components: { LineChart, StockChart, HLineChart },
  props: ["text", "colorgraph", "heightgrapg", "id", "datachart"],
  data() {
    return {
      options1: [
        { text: "Daily", value: 1 },
        { text: "Manual", value: 2 },
      ],
      radios_hr: "4",
      dateRange: {
        start: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
        end: new Date(),
      },
      select1: 1,
      textSelect: "",
      datacollection_power: null,
      option_power: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: true,
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                steps: 5,
                stepValue: 5,
              },
              position: "left",
              scaleLabel: {
                display: false,
                labelString: "m3",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      datasets3: [
        {
          label: "X-Axis",
          fill: false,
          data: [2, 9, 12, 23, 14, 25, 6, 21],
          borderWidth: 2,
          borderColor: "#fd7e14",
        },
        {
          label: "Y-Axis",
          fill: false,
          data: [22, 19, 12, 8, 14, 5, 6, 13],
          borderWidth: 2,
          borderColor: "#20c997",
        },
        {
          label: "Z-Axis",
          data: [12, 11, 22, 30, 24, 15, 26, 27],
          borderWidth: 1.5,
          fill: false,
          borderColor: "#e83e8c",
        },
      ],
      dataChart12hr: [],
      labelsChart12hr: [],
      dataChartbytime: [],
      labelsChartbytime: [],

      xHChart12hr: [],
      yHChart12hr: [],
      zHChart12hr: [],
      xHChartbytime: [],
      yHChartbytime: [],
      zHChartbytime: [],

      stockChart: {
        chart: {
          backgroundColor: "transparent",
        },
        rangeSelector: {
          selected: 1,
        },

        title: {
          text: "Vibration Sensor Graph",
          align: "left",
          style: {
            color: "#808080",
            fontSize: "18px",
            "font-weight": "900",
          },
        },

        series: [
          {
            name: "AAPL",
            data: [],
            tooltip: {
              valueDecimals: 2,
            },
          },
          {
            name: "BBPL",
            data: [],
            tooltip: {
              valueDecimals: 2,
            },
          },
          {
            name: "CCPL",
            data: [],
            tooltip: {
              valueDecimals: 2,
            },
          },
        ],
      },
      updated: 0,
      linechart: {
        chart: {
          type: "spline",
          backgroundColor: "transparent",
        },
        title: {
          text: "Vibration Sensor Graph",
          style: {
            fontSize: "0px",
          },
        },
        xAxis: {
          type: "datetime",
          // dateTimeLabelFormats: { // don't display the dummy year
          //     month: '%e. %b',
          //     year: '%b'
          // },
          title: {
            text: "Date",
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          min: 0,
        },
        tooltip: {
          headerFormat: "<b>{series.name}</b><br>",
          pointFormat: "{point.x:%e. %b %H:%M}: <b>{point.y:.2f}</b> ",
        },

        plotOptions: {
          series: {
            marker: {
              enabled: true,
            },
          },
        },

        colors: ["#fd7e14", "#20c997", "#e83e8c", "#036", "#000"],

        // Define the data points. All series have a dummy year
        // of 1970/71 in order to be compared on the same x axis. Note
        // that in JavaScript, months start at 0 for January, 1 for February etc.
        series: [],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                plotOptions: {
                  series: {
                    marker: {
                      radius: 2.5,
                    },
                  },
                },
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    linechartCom: {
      get() {
        return this.linechart;
      },
      set(val) {
        this.linechart.series = val;
      },
    },
  },
  methods: {
    closeModal() {
      this.$refs["settingChart"].hide();
    },
    linechart() {
      this.datacollection_power = {
        labels: ["8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am", "2am"],
        datasets: this.datasets3,
      };
      this.option_power = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: true,
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                steps: 5,
                stepValue: 5,
              },
              position: "left",
              scaleLabel: {
                display: false,
                labelString: "m3",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };
    },
    async getDataChart() {
      // let res = await this.$API.get(`hino/getchart/${this.id}`);
      // console.log("hino/getchart", res);
      // // this.dataChart = [];
      // this.dataChart12hr.push(res.data.x);
      // this.dataChart12hr.push(res.data.y);
      // this.dataChart12hr.push(res.data.z);
      // this.labelsChart12hr = res.data.timestamp;

      // for (let i = 0; i < res.data.timestamp.length; i++) {
      //   const day = res.data.timestamp[i].split(" ")
      //   // let formatday = day[0]+' '+day[1]+', '+ new Date().getFullYear()+' '+day[2]+':00'
      //    let formatday = res.data.timestamp[i]
      //   // console.log(formatday);
      //   const d = new Date(formatday).getTime()
      //   this.xHChart12hr.push([d,res.data.x[i]])
      //   this.yHChart12hr.push([d,res.data.y[i]])
      //   this.zHChart12hr.push([d,res.data.z[i]])
      // }

      console.log(this.datachart);
      this.xHChart12hr = this.datachart.x;
      this.yHChart12hr = this.datachart.y;
      this.zHChart12hr = this.datachart.z;
      console.log(this.xHChart12hr);

      this.selectDataChart();
    },
    async selectDataChart() {
      let newdata = [];
      let newlabels = [];
      if (this.select1 == 1) {
        let index =
          this.xHChart12hr.length -
          Math.round(this.xHChart12hr.length / this.radios_hr);
        console.log(index);
        newlabels = this.labelsChart12hr.slice(index);
        // this.datasets3[0].data = this.xHChart12hr.slice(index);
        // this.datasets3[1].data = this.yHChart12hr.slice(index);
        // this.datasets3[2].data = this.zHChart12hr.slice(index);
        // for (let i = 0; i < this.datasets3.length; i++) {
        //   newdata = this.dataChart12hr[i].slice(index);
        //   console.log("newdata", newdata.length);
        //   this.datasets3[i].data = newdata;
        // }
        // this.datacollection_power = {
        //   labels: newlabels,
        //   datasets: this.datasets3,
        // };
        this.textSelect =
          this.options1[this.select1 - 1].text +
          " " +
          (this.radios_hr == 4 ? "3hr" : this.radios_hr == 2 ? "6hr" : "12hr");
        // console.log(this.datascatter.datasets[0].data);
        // if (this.radios_hr == '4') {
        this.linechartCom = [];
        this.linechart.series.push({
          name: "X-Axis",
          data: this.xHChart12hr.slice(index),
        });
        this.linechart.series.push({
          name: "Y-Axis",
          data: this.yHChart12hr.slice(index),
        });
        this.linechart.series.push({
          name: "Z-Axis",
          data: this.zHChart12hr.slice(index),
        });
        this.updated = !this.updated;
        // }
      } else {
        await this.getDataChartbyTime();
      }
    },
    async getDataChartbyTime() {
      let body = {
        id: String(this.id),
        start: this.$moment(this.dateRange.start).format("YYYY-MM-DD HH:mm:ss"),
        end: this.$moment(this.dateRange.end).format("YYYY-MM-DD HH:mm:ss"),
      };
      console.log(body);
      let res = await this.$API.post("hino/getchartbytime", body);
      console.log("hino/getchartbytime", res);
      // this.dataChartbytime = [];
      // this.dataChartbytime.push(res.data.x);
      // this.dataChartbytime.push(res.data.y);
      // this.dataChartbytime.push(res.data.z);
      // this.labelsChartbytime = res.data.timestamp;

      // let newdata = [];
      // let newlabels = this.labelsChartbytime;

      // for (let i = 0; i < this.datasets3.length; i++) {
      //   newdata = this.dataChartbytime[i];
      //   console.log("newdata", newdata.length);
      //   this.datasets3[i].data = newdata;
      // }

      // this.datacollection_power = {
      //   labels: newlabels,
      //   datasets: this.datasets3,
      // };

      // for (let i = 0; i < res.data.timestamp.length; i++) {
      //   const day = res.data.timestamp[i].split(" ")
      //   // let formatday = day[0]+' '+day[1]+', '+ new Date().getFullYear()+' '+day[2]+':00'
      //    let formatday = res.data.timestamp[i]
      //   // console.log(formatday);
      //   const d = new Date(formatday).getTime()
      //   this.xHChartbytime.push([d,res.data.x[i]])
      //   this.yHChartbytime.push([d,res.data.y[i]])
      //   this.zHChartbytime.push([d,res.data.z[i]])
      // }
      this.xHChartbytime = res.data.x;
      this.yHChartbytime = res.data.y;
      this.zHChartbytime = res.data.z;
      this.linechartCom = [];
      this.linechart.series.push({
        name: "X-Axis",
        data: this.xHChartbytime,
      });
      this.linechart.series.push({
        name: "Y-Axis",
        data: this.yHChartbytime,
      });
      this.linechart.series.push({
        name: "Z-Axis",
        data: this.zHChartbytime,
      });
      this.updated = !this.updated;

      this.textSelect =
        this.options1[this.select1 - 1].text +
        " " +
        body.start +
        " - " +
        body.end;
    },
    accept() {
      console.log("accept");
      this.selectDataChart();
      this.$refs["settingChart"].hide();
    },
  },
  async mounted() {
    // this.linechart();
    this.getDataChart();
  },
  watch: {
    datachart: {
      // watch it
      handler(newValue, oldValue) {
        console.log("redraw chart datachart");
        // console.log(newValue, oldValue);
        this.getDataChart();
      },
      deep: true,
    },
  },
};
</script>

<style  lang="scss"  scoped>
.btnBorderpop {
  border-radius: 20px;
  width: 80px;
}
.al-center {
  align-items: center;
}

#selectitem {
  display: flex;
  align-items: center;
}
#selectitem a {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
}
.select-date {
  display: flex;
  align-items: center;
  color: #808080;
  flex-wrap: wrap;
  .date-range {
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px #808080 solid;
    border-radius: 30px;
    padding: 8px;
    background-color: #fff;
    div {
    }
  }
}
</style>